import _ from 'lodash';
import {
  CellPosition,
  Cell,
  Cells,
  Sheet,
  CellHistory,
  CellValue,
  CellsReferences,
  CellReference,
} from '../../types';

export const getCell = <T extends Cells | CellsReferences>(
  cells: T,
  position: CellPosition
): T[number][number] | undefined => {
  const cell = cells[position.ri]?.[position.ci];

  return cell;
};

export const createCell = <T extends Cells | CellsReferences>(
  cells: T,
  { ri, ci }: CellPosition
): T[number][number] => {
  let cell = cells[ri]?.[ci];

  if (!cell) {
    if (!cells[ri]) cells[ri] = [];

    cell = cells[ri][ci] = {};
  }

  return cell;
};

export const deleteCell = <T extends Cells | CellsReferences>(
  cells: T,
  position: CellPosition
) => {
  delete cells[position.ri]?.[position.ci];
};

export const deleteCellResultDepFormat = (
  cells: Cells,
  position: CellPosition
) => {
  const cell = getCell(cells, position);
  if (cell) {
    delete cell.r;
    // TODO: Delete Dependent cell Format
  }
};

// export const deleteCellNumberFormat = (
//   cellsReferences: CellsReferences,
//   cellRef: CellReference | undefined,
//   position: CellPosition
// ) => {
//   if (cellRef) {
//     delete cellRef.nf;
//     if (_.isEmpty(cellRef)) deleteCell(cellsReferences, position);
//   }
// };

// export const deleteCellStyle = (
//   cellsReferences: CellsReferences,
//   cellRef: CellReference | undefined,
//   position: CellPosition
// ) => {
//   if (cellRef) {
//     delete cellRef.s;
//     if (_.isEmpty(cellRef)) deleteCell(cellsReferences, position);
//   }
// };

// export const saveCellHistory = (
//   cells: Cells,
//   newHistory: CellHistory,
//   { ci, ri }: CellPosition
// ) => {
//   if (!cellsHistory[ri]) cellsHistory[ri] = [];

//   if (!cellsHistory[ri][ci]) cellsHistory[ri][ci] = [];

//   const history = cellsHistory[ri][ci];

//   cellsHistory[ri][ci] = [newHistory, ...history].slice(0, 5);
// };

export const saveCellValueWithHistory = (
  cells: Cells,
  position: CellPosition,
  text: CellValue,
  newHistory: CellHistory
) => {
  const cell = createCell(cells, position);
  // let cell = cells[ri]?.[ci];

  // if (!cell) {
  //   if (!cells[ri]) cells[ri] = [];

  //   cell = cells[ri][ci] = {};
  // }

  cell.v = text;

  const existingHistory = cell?.h || [];
  const history = [newHistory, ...existingHistory].slice(0, 5);

  cell.h = history;

  return cell;
};

export const isCellFormula = (cell: Cell | undefined): boolean => {
  if (!cell) {
    return false;
  }

  const value = cell.v;

  if (typeof value !== 'string') {
    return false;
  }

  return value.startsWith('=');
};

export const getCellVisibleValue = (cells: Cells, position: CellPosition) => {
  const cell = getCell(cells, position);
  let visibleValue = '';
  let isError = false;
  if (cell) {
    const value = cell.r ?? cell.v ?? '';
    visibleValue = value.toString();
    if (visibleValue.startsWith('#')) {
      const [err, _] = visibleValue.split(':');
      visibleValue = err;
      isError = true;
    }
  }

  return {
    visibleValue,
    isError,
  };
};
